<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon *ngIf="!!isBrowse">visibility</mat-icon>
        <mat-icon *ngIf=" !isBrowse">create</mat-icon>
        <h1 *ngIf=" !isAdded && !!isBrowse">{{'スレッド：閲覧' | translate }}</h1>
        <h1 *ngIf=" !isAdded &&  !isBrowse">{{'スレッド：編集' | translate }}</h1>
        <h1 *ngIf="!!isAdded">{{'スレッド：追加' | translate }}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="10px">
        <button *ngIf="!!isAdded" mat-raised-button color="primary" (click)="addThread()" [disabled]="!boardThreadFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span>{{'追加' | translate}}</span>
        </button>
        <button *ngIf="!isAdded && !isBrowse" mat-raised-button color="warn" (click)="delThread()" [disabled]="!boardThreadFormGroup.valid">
          <mat-icon>delete</mat-icon>
          <span>{{'削除' | translate}}</span>
        </button>
        <button *ngIf="!isAdded && !isBrowse" mat-raised-button color="primary" (click)="updThread()" [disabled]="!boardThreadFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content>
    <form class="form" [formGroup]="boardThreadFormGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="10px">

        <mat-form-field fxFlex="100%">
          <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
          <input matInput *ngIf="!!isBrowse" placeholder="{{'名称' | translate}}" id="threadName" formControlName="threadName" readonly>
          <input matInput *ngIf=" !isBrowse" placeholder="{{'名称' | translate}}" id="threadName" formControlName="threadName">
          <mat-error *ngIf="threadNameControl.invalid">{{ getErrorMessageToThreadName() }}</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="100%">
          <mat-label floatLabel="always">{{'内容' | translate}}</mat-label>
          <textarea matInput *ngIf="!!isBrowse" placeholder="{{'内容' | translate}}" id="threadDesc" formControlName="threadDesc" rows="8" readonly></textarea>
          <textarea matInput *ngIf=" !isBrowse" placeholder="{{'内容' | translate}}" id="threadDesc" formControlName="threadDesc" rows="8"></textarea>
          <mat-error *ngIf="threadDescControl.invalid">{{ getErrorMessageToThreadDesc() }}</mat-error>
        </mat-form-field>

        <div *ngIf="!!isAdded">
          <div class="dropzone2">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <input #fileInput1 class="fileinput" type="file" (change)="onChangeFile1Input($event)" accept="image/*">
              <button mat-icon-button (click)="onFile1ClearClick()">
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>
        </div>

        <div *ngIf="!isAdded && !isBrowse">
          <div *ngIf="!!boardThread.thread_image">
            <div class="dropzone2">
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <img *ngIf="!!boardThread.thread_image" [src]="boardThread.thread_image.download_url" height="70px"
                  width="auto">
                <button mat-icon-button (click)="onImageClearClick()">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <div *ngIf="!boardThread.thread_image">
            <div class="dropzone2">
              <div fxLayout="row" fxLayoutAlign="space-between center">
                <input #fileInput2 class="fileinput" type="file" (change)="onChangeFile2Input($event)" accept="image/*">
                <button mat-icon-button (click)="onFile2ClearClick()">
                  <mat-icon>clear</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!isAdded && !!isBrowse">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <img *ngIf="!!boardThread.thread_image" [src]="boardThread.thread_image.download_url" width="100%"
              height="auto">
          </div>
        </div>

      </div>
    </form>
  </div>


</div>